import { appConfig } from "@/app/app-config";
import { initAppState } from "@/app/init";
import { parseJwtPayload } from "@/core_bridge/module_api";
import { useStore } from "@/state/legacy_module_api";

let session_bootstrapped = false;
let last_token: string | null | undefined = undefined;

function sync_sentry_user(token: string | null | undefined) {
  if (!token) return;
  try {
    const jwt = parseJwtPayload(token);
    if (jwt?.user_id) {
      window.Sentry?.setUser({
        id: jwt.user_id,
        appId: appConfig.appId,
      });
    }
  } catch (err) {
    console.warn("[bootstrap/session] failed to sync Sentry user", err);
  }
}

export async function bootSession(token?: string): Promise<void> {
  if (!session_bootstrapped) {
    await initAppState();
    session_bootstrapped = true;
  }

  const store = useStore.getState();
  const store_token = store.apiToken;
  if (token !== undefined && store_token != null && token !== store_token) {
    console.debug("[bootstrap/session] ignoring stale token argument");
  } else if (store_token == null && token !== undefined) {
    store.setApiToken(token);
  }

  const effective_token = useStore.getState().apiToken ?? token;
  if (effective_token !== last_token) {
    sync_sentry_user(effective_token ?? null);
    last_token = effective_token ?? null;
  }
}
